// REACT
import React from "react";

// MATERIAL-UI
import { List, ListItemButton, ListItemText, Typography } from "@mui/material";

// COMPONENTS
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import InfiniteScroll from "react-infinite-scroll-component";
import Preloader from "src/utils/Preloader";

// ASSETS
import { walletDrawerstyles } from "../common/styles/WalletDrawer.styles";
// import GA from "src/analytics/googleAnalytics";
import { BottomDrawerList, Data } from "../common/types/dropdownTypes";

const BottomDrawList = (props: BottomDrawerList) => {
  const classes = walletDrawerstyles();

  const [data, setData] = React.useState<Data[]>([]);
  const [hasMore, setHasMore] = React.useState<boolean>(true);

  const upNext = () => {
    if (data.length >= props.data.length) {
      setHasMore((prev) => !prev);
    }

    setTimeout(() => {
      setData((prev) => [...prev, ...props.data.slice(prev.length, prev.length + 10)]);
    }, 1000);
  };

  React.useEffect(() => {
    setData(props.data.slice(0, 10));
  }, [props.data]);

  return (
    <>
      {props.searchTerm && props.searchTerm > 0 ? (
        <>
          {props.data &&
            props.data.map((el) => (
              <List
                id="deposit-drawer-list"
                key={el.code}
                sx={{
                  width: "100%",
                  padding: "0px",
                  height: "100%",
                }}>
                <ListItemButton
                  className="deposit-drawer-list-item"
                  data-code={el.code}
                  data-icon={el?.logoUrl}
                  data-name={el.name}
                  data-value={el.value}
                  data-price={el.price}
                  data-available={el.available}
                  data-memo={el.memo?.toString()}
                  data-depositable={el.depositable?.toString()}
                  data-inactive={el.inactive?.toString()}
                  onClick={(event) => props.onClick(event, el.code)}>
                  <span className={classes.icon}>
                    <CountryOrCryptoFlag name={el?.logoUrl || el.code} size={30} />
                  </span>
                  <ListItemText
                    className={classes.listContainer}
                    primary={<Typography className={classes.Title}>{el.code}</Typography>}
                    secondary={<Typography>{el.name}</Typography>}
                  />
                </ListItemButton>
              </List>
            ))}
        </>
      ) : (
        <InfiniteScroll
          dataLength={data.length}
          next={upNext}
          hasMore={hasMore}
          height={600}
          loader={<Preloader />}
          className={classes.infiniteScroll}
          endMessage={
            <>
              {data.length <= 10 ? (
                <p></p>
              ) : (
                <p style={{ textAlign: "center" }}>
                  <b>Yay! You have seen it all</b>
                </p>
              )}
            </>
          }>
          {data.map((el) => (
            <List
              id="deposit-drawer-list"
              key={el.code}
              sx={{
                width: "100%",
                padding: "0px",
              }}>
              <ListItemButton
                className="deposit-drawer-list-item"
                data-code={el.code}
                data-icon={el?.logoUrl}
                data-name={el.name}
                data-value={el.value}
                data-price={el.price}
                data-available={el.available}
                data-memo={el.memo?.toString()}
                data-depositable={el.depositable?.toString()}
                data-inactive={el?.inactive?.toString()}
                onClick={(event) => props.onClick(event, el.code)}>
                <span className={classes.icon}>
                  <CountryOrCryptoFlag name={el?.logoUrl || el.code} size={30} />
                </span>
                <ListItemText
                  className={classes.listContainer}
                  primary={<Typography className={classes.Title}>{el.code}</Typography>}
                  secondary={<Typography>{el.name}</Typography>}
                />
              </ListItemButton>
            </List>
          ))}
        </InfiniteScroll>
      )}
    </>
  );
};

export default BottomDrawList;
